import http from '@/http';

const TipoDeProjetoService = {
  async getLkpTipoProjeto() {
    const dataTipoProjeto = await http.get("/api/astec/getLkpTipoProjeto");
    return dataTipoProjeto.data.map(tp => ({
      name: tp.DISPLAY,
      value: tp.ID
    }));
  }
};

export default TipoDeProjetoService;
